import { t } from '@/plugins/i18n'
export const d2cShoppingColumns:any = [
  {
    label: t('序号'),
    type: 'index',
    width: 100,
    align: 'center'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    width: 180
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    align: 'center'
  },
  {
    label: t('数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('总价（RMB）'),
    prop: 'actualTotalProductSellPrice',
    align: 'center'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('详情费用'),
    prop: 'feeInfo',
    align: 'center',
    slotName: 'feeInfo'
  },
  {
    label: t('国内运费'),
    prop: 'domesticShipping',
    align: 'center'
  },
  {
    label: t('代买手续费'),
    prop: 'purchasingFee',
    align: 'center'
  },
  {
    label: t('结算状态'),
    prop: 'settleStatus',
    align: 'center',
    slotName: 'settleStatus'
  },
  {
    label: t('入库手续费'),
    prop: 'storageFee',
    align: 'center'
  },
  {
    label: t('质检手续费'),
    prop: 'qualityInspectionFee',
    align: 'center'
  },
  {
    label: t('发货手续费'),
    prop: 'shippingFee',
    align: 'center'
  },
  {
    label: t('附加项费用'),
    prop: 'additionalFee',
    align: 'center'
  }
]
export const d2cShoppingColumns1:any = [
  {
    label: t('序号'),
    type: 'index',
    width: 100,
    align: 'center',
    fixed: 'left'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    align: 'center',
    slotName: 'shoppingInfo',
    fixed: 'left'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    width: 180
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    width: 120
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionDTOList',
    width: 160,
    align: 'center',
    slotName: 'platformOrderItemAdditionDTOList'
  },
  {
    label: t('商品所在地'),
    prop: 'goodsCountry',
    align: 'center',
    slotName: 'goodsCountry',
    isMultiStore: true
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    align: 'center',
    slotName: 'actualProductSellPrice'
  },
  {
    label: t('数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('总价2'),
    prop: 'actualTotalProductSellPrice',
    align: 'center',
    slotName: 'actualTotalProductSellPrice'
  },
  {
    label: t('最终采购价'),
    prop: 'final',
    align: 'center',
    slotName: 'final',
    slotHeadName: 'finalHead',
    width: 180
  },
  {
    label: t('采购均价'),
    prop: 'averagePrice',
    align: 'center',
    slotName: 'averagePrice',
    width: 180
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('详情费用'),
    prop: 'feeInfo',
    align: 'center',
    slotName: 'feeInfo'
  },
  {
    label: t('代买手续费') + '/' + t('档口手续费'),
    prop: 'purchasingFee',
    align: 'center',
    slotName: 'purchasingFee'
  },
  {
    label: t('结算状态'),
    prop: 'settleStatus',
    align: 'center',
    slotName: 'settleStatus'
  },
  {
    label: t('国内运费'),
    prop: 'domesticShipping',
    slotName: 'domesticShipping',
    align: 'center'
  },
  {
    label: t('入库手续费'),
    prop: 'storageFee',
    align: 'center',
    slotName: 'storageFee'
  },
  {
    label: t('出库手续费'),
    prop: 'deliverStorageFee',
    align: 'center',
    slotName: 'deliverStorageFee'
  },
  // {
  //   label: t('国际运费') + '?',
  //   prop: 'storageFee1',
  //   align: 'center'
  // },
  // {
  //   label: t('发货附加项') + '?',
  //   prop: 'storageFee1',
  //   align: 'center'
  // },
  {
    label: t('商品附加项费用'),
    prop: 'additionalFee',
    slotName: 'additionalFee',
    align: 'center'
  }

  // {
  //   label: t('质检手续费'),
  //   prop: 'qualityInspectionFee',
  //   align: 'center'
  // },
  // {
  //   label: t('发货手续费'),
  //   prop: 'shippingFee',
  //   align: 'center'
  // },
  // {
  //   label: t('附加项费用'),
  //   prop: 'additionalFee',
  //   align: 'center'
  // }
]

export const d2cShoppingColumns2:any = [
  {
    label: t('序号'),
    type: 'index',
    width: 100,
    align: 'center'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    align: 'center'
  },
  {
    label: t('数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('总价（RMB）'),
    prop: 'actualTotalProductSellPrice',
    align: 'center'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('详情费用'),
    prop: 'feeInfo',
    align: 'center',
    slotName: 'feeInfo'
  },
  {
    label: t('代买手续费'),
    prop: 'purchasingFee',
    align: 'center'
  },
  {
    label: t('结算状态'),
    prop: 'settleStatus',
    align: 'center',
    slotName: 'settleStatus'
  },
  {
    label: t('国内运费'),
    prop: 'domesticShipping',
    align: 'center'
  },
  {
    label: t('入库手续费'),
    prop: 'storageFee',
    align: 'center'
  },
  {
    label: t('出库手续费'),
    prop: 'deliverStorageFee',
    align: 'center'
  },
  // {
  //   label: t('国际运费') + '?',
  //   prop: 'storageFee1',
  //   align: 'center'
  // },
  // {
  //   label: t('发货附加项') + '?',
  //   prop: 'storageFee1',
  //   align: 'center'
  // },
  {
    label: t('商品附加项费用'),
    prop: 'additionalFee',
    align: 'center'
  }

  // {
  //   label: t('质检手续费'),
  //   prop: 'qualityInspectionFee',
  //   align: 'center'
  // },
  // {
  //   label: t('发货手续费'),
  //   prop: 'shippingFee',
  //   align: 'center'
  // },
  // {
  //   label: t('附加项费用'),
  //   prop: 'additionalFee',
  //   align: 'center'
  // }
]
export const b2bShoppingColumns:any = [
  {
    label: t('序号'),
    type: 'index',
    width: 100,
    align: 'center',
    fixed: 'left'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    align: 'center',
    slotName: 'shoppingInfo',
    fixed: 'left'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    width: 180
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    width: 120
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionDTOList',
    width: 160,
    align: 'center',
    slotName: 'platformOrderItemAdditionDTOList'
  },
  {
    label: t('商品所在地'),
    prop: 'goodsCountry',
    align: 'center',
    slotName: 'goodsCountry',
    isMultiStore: true
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    align: 'center',
    slotName: 'actualProductSellPrice'
  },
  {
    label: t('数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('总价'),
    prop: 'actualTotalProductSellPrice',
    slotName: 'actualTotalProductSellPrice',
    align: 'center'
  },
  {
    label: t('最终采购价'),
    prop: 'final',
    align: 'center',
    slotName: 'final',
    slotHeadName: 'finalHead',
    width: 180
  },
  {
    label: t('采购均价'),
    prop: 'averagePrice',
    align: 'center',
    slotName: 'averagePrice',
    width: 180
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('代买手续费') + '/' + t('档口手续费'),
    prop: 'purchasingFee',
    align: 'center',
    slotName: 'purchasingFee'
  },
  {
    label: t('结算状态'),
    prop: 'settleStatus',
    align: 'center',
    slotName: 'settleStatus'
  },
  {
    label: t('国内运费'),
    prop: 'domesticShipping',
    align: 'center',
    slotName: 'domesticShipping'
  },
  {
    label: t('入库手续费'),
    prop: 'storageFee',
    align: 'center',
    slotName: 'storageFee'
  },
  {
    label: t('出库手续费'),
    prop: 'deliverStorageFee',
    align: 'center',
    slotName: 'deliverStorageFee'
  }
]

export const tableConfig = {
  showExpand: true,
  canRowClick: true,
  rowKey: 'platformOrderItemId',
  expandConfigId: 'combinationOrderItemList',
  height: 400
}

export const columns:any = [
  {
    label: t('发货单号'),
    prop: 'deliveryTaskCode',
    slotName: 'deliveryTaskCode',
    width: 220
  },
  {
    label: t('生成时间'),
    prop: 'createTime',
    align: 'center',
    slotName: 'createTime'
  },
  {
    label: t('国际运单号'),
    prop: 'logisticsCode',
    align: 'center',
    slotName: 'logisticsCode'
  },
  {
    label: t('计费重量') + '(g)',
    prop: 'weight',
    align: 'center',
    choiceHidden: 1
  },
  {
    label: t('国际运费'),
    prop: 'freightFee',
    align: 'center',
    slotName: 'freightFee'
  },
  {
    label: t('附加项费用'),
    prop: 'additionalFee',
    align: 'center',
    slotName: 'additionalFee',
    choiceHidden: 1
  },
  {
    label: t('发货费用总额'),
    prop: 'deliveryFee',
    slotName: 'deliveryFee',
    align: 'center',
    choiceHidden: 1
  },
  {
    label: t('是否发货'),
    prop: 'deliveryStatus',
    slotName: 'deliveryStatus',
    align: 'center'
  },
  {
    label: t('发货时间'),
    prop: 'deliveryTime',
    align: 'center',
    slotName: 'deliveryTime'
  }
]

export const childColumns:any = [
  {
    label: t('商品番号'),
    prop: 'customerProductNo',
    align: 'center'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    slotName: 'productPropertiesName'
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center'
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    align: 'center',
    slotName: 'actualProductSellPrice',
    choiceHidden: 1
  },
  {
    label: t('下单数量'),
    prop: 'deliveryNums',
    align: 'center'
  },
  {
    label: t('总价'),
    prop: 'actualTotalProductSellPrice',
    align: 'center',
    slotName: 'actualTotalProductSellPrice',
    choiceHidden: 1
  }
  // {
  //   label: t('商品状态'),
  //   prop: 'orderItemStatus',
  //   align: 'center',
  //   slotName: 'orderItemStatus'
  // }
]

export const feeColumns:any = [
  {
    label: t('数量'),
    prop: 'num',
    align: 'center'
  },
  {
    label: t('费用类型'),
    prop: 'feeType',
    align: 'center'
  },
  {
    label: t('费用明细'),
    prop: 'feeInfo',
    align: 'center'
  },
  {
    label: t('时间'),
    prop: 'time',
    align: 'center'
  }
]

// 之前一样的数据。供子表格使用
export const d2cShoppingColumns1NEW:any = [
  {
    label: t('序号'),
    type: 'index',
    width: 100,
    align: 'center'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    width: 180
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    width: 120
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品所在地'),
    prop: 'goodsCountry',
    align: 'center',
    slotName: 'goodsCountry',
    isMultiStore: true
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    slotName: 'actualProductSellPrice',
    align: 'center'
  },
  {
    label: t('数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('总价'),
    prop: 'actualTotalProductSellPrice',
    slotName: 'actualTotalProductSellPrice',
    align: 'center'
  },
  {
    label: t('最终采购价'),
    prop: 'final',
    align: 'center',
    slotName: 'final',
    slotHeadName: 'finalHead',
    width: 180
  },
  {
    label: t('采购均价'),
    prop: 'averagePrice',
    align: 'center',
    slotName: 'averagePrice',
    width: 180
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionDTOList',
    width: 160,
    align: 'center',
    slotName: 'platformOrderItemAdditionDTOList'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('详情费用'),
    prop: 'feeInfo',
    align: 'center',
    slotName: 'feeInfo'
  },
  {
    label: t('代买手续费') + '/' + t('档口手续费'),
    prop: 'purchasingFee',
    align: 'center',
    slotName: 'purchasingFee'
  },
  {
    label: t('结算状态'),
    prop: 'settleStatus',
    align: 'center',
    slotName: 'settleStatus'
  },
  {
    label: t('国内运费'),
    prop: 'domesticShipping',
    slotName: 'domesticShipping',
    align: 'center'
  },
  {
    label: t('入库手续费'),
    prop: 'storageFee',
    slotName: 'storageFee',
    align: 'center'
  },
  {
    label: t('出库手续费'),
    prop: 'deliverStorageFee',
    slotName: 'deliverStorageFee',
    align: 'center'
  },
  // {
  //   label: t('国际运费') + '?',
  //   prop: 'storageFee1',
  //   align: 'center'
  // },
  // {
  //   label: t('发货附加项') + '?',
  //   prop: 'storageFee1',
  //   align: 'center'
  // },
  {
    label: t('商品附加项费用'),
    prop: 'additionalFee',
    slotName: 'additionalFee',
    align: 'center'
  }

  // {
  //   label: t('质检手续费'),
  //   prop: 'qualityInspectionFee',
  //   align: 'center'
  // },
  // {
  //   label: t('发货手续费'),
  //   prop: 'shippingFee',
  //   align: 'center'
  // },
  // {
  //   label: t('附加项费用'),
  //   prop: 'additionalFee',
  //   align: 'center'
  // }
]

// 之前一样的数据。供子表格使用
export const b2bShoppingColumnsNEW:any = [
  {
    label: t('序号'),
    type: 'index',
    width: 100,
    align: 'center'
  },
  {
    label: t('商品信息'),
    prop: 'shoppingInfo',
    width: 250,
    align: 'center',
    slotName: 'shoppingInfo'
  },
  {
    label: t('商品规格'),
    prop: 'productPropertiesName',
    align: 'center',
    width: 180
  },
  {
    label: t('客户商品sku'),
    prop: 'customerProductMsku',
    align: 'center',
    width: 120
  },
  {
    label: t('平台商品SKU'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('商品所在地'),
    prop: 'goodsCountry',
    align: 'center',
    slotName: 'goodsCountry',
    isMultiStore: true
  },
  {
    label: t('商品单价'),
    prop: 'actualProductSellPrice',
    slotName: 'actualProductSellPrice',
    align: 'center'
  },
  {
    label: t('数量'),
    prop: 'orderQuantity',
    align: 'center'
  },
  {
    label: t('总价'),
    prop: 'actualTotalProductSellPrice',
    slotName: 'actualTotalProductSellPrice',
    align: 'center'
  },
  {
    label: t('最终采购价'),
    prop: 'final',
    align: 'center',
    slotName: 'final',
    slotHeadName: 'finalHead',
    width: 180
  },
  {
    label: t('采购均价'),
    prop: 'averagePrice',
    align: 'center',
    slotName: 'averagePrice',
    width: 180
  },
  {
    label: t('商品附加项'),
    prop: 'platformOrderItemAdditionDTOList',
    width: 160,
    align: 'center',
    slotName: 'platformOrderItemAdditionDTOList'
  },
  {
    label: t('商品状态'),
    align: 'center',
    slotName: 'shoppingStats'
  },
  {
    label: t('代买手续费') + '/' + t('档口手续费'),
    prop: 'purchasingFee',
    align: 'center',
    slotName: 'purchasingFee'
  },
  {
    label: t('结算状态'),
    prop: 'settleStatus',
    align: 'center',
    slotName: 'settleStatus'
  },
  {
    label: t('国内运费'),
    prop: 'domesticShipping',
    align: 'center',
    slotName: 'domesticShipping'
  },
  {
    label: t('入库手续费'),
    prop: 'storageFee',
    align: 'center',
    slotName: 'storageFee'
  },
  {
    label: t('出库手续费'),
    prop: 'deliverStorageFee',
    align: 'center',
    slotName: 'deliverStorageFee'
  }
]
